import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import propTypes from 'prop-types'
import { Col, Form, Input, InputNumber, List, Popconfirm, Row } from 'antd'
import { ExclamationOutlined } from '@ant-design/icons'
import {
  addEditEvent,
  deleteEvent,
  setEventList,
} from '../../store/action/event.action'
import serviceInterface from '../../services/service.interface'

const EventItem = (props) => {
  const [edit, setEdit] = useState(false)
  var form = useRef()

  useEffect(() => {
    if (edit) {
      form.current.setFieldsValue({ ...props.event })
    }
  }, [edit])

  // const handleSubmit = (values) => {
  //     props.editEvent({
  //         surgerytype: props.surgerytype,
  //         customer: props.customer?._id,
  //         company: props.company?._id,
  //         event: {
  //             ...values,
  //             _id: props.event._id
  //         }
  //     }, props.events).then((res) => setEdit(false));
  // }

  // const handleDelete = (values) => {
  //     props.deleteEvent({
  //         surgerytype: props.surgerytype,
  //         customer: props.customer?._id,
  //         company: props.company?._id,
  //         event: {
  //             _id: props.event._id
  //         }
  //     }, props.events).then((res) => setEdit(false));
  // }

  const handleSubmit = (values) => {
    if (
      props.event?.date == values.date &&
      props.event?.title.trim().toLowerCase() ==
        values.title.trim().toLowerCase() &&
      props.event?.message.trim().toLowerCase() ==
        values.message.trim().toLowerCase()
    ) {
      setEdit(false)
    } else {
      var events = serviceInterface
        .EventService()
        .modifyEvents(
          JSON.parse(JSON.stringify(props.events)),
          { ...values, isEdited: true, _id: props.event._id },
          false
        )
      props.setEvents(events, props.surgerytype)
      setEdit(false)
    }
  }

  const handleDelete = (values) => {
    var events = serviceInterface
      .EventService()
      .modifyEvents(
        JSON.parse(JSON.stringify(props.events)),
        { ...props.event, isEdited: true, isDeleted: true },
        false
      )
    props.setEvents(events, props.surgerytype)
    setEdit(false)
  }

  return (
    <List.Item
      hidden={props.event.isDeleted}
      actions={
        edit
          ? [
              <a onClick={() => form.current.submit()}>save</a>,
              <a onClick={() => setEdit(false)}>cancel</a>,
            ]
          : [
              <div id={'editdeletereminder'}>
                {' '}
                <a onClick={() => setEdit(true)}>edit</a>,
                <Popconfirm
                  title='Are you sure？'
                  okText='Yes'
                  cancelText='No'
                  onConfirm={handleDelete}
                >
                  <a>delete</a>
                </Popconfirm>
              </div>,
            ]
      }
    >
      {!edit && (
        <>
          <List.Item.Meta
            avatar={<ExclamationOutlined style={{ color: 'red' }} />}
            title={props.event?.title}
            description={props.event?.message}
          />
          <Col flex='120px'>
            S{' '}
            {props.event?.date >= 0
              ? '+ ' + props.event?.date
              : '- ' + Math.abs(props.event?.date)}
          </Col>
        </>
      )}
      <Form
        onFinish={handleSubmit}
        ref={form}
        hidden={!edit}
        layout='vertical'
        className='event-form'
      >
        <Row align='middle'>
          <Col flex='60%'>
            <Row wrap={false} gutter={5}>
              <Col flex={'70%'}>
                <Form.Item
                  className='ef-item'
                  name='title'
                  rules={[{ required: true }]}
                  label='Title'
                >
                  <Input placeholder={'Title'} />
                </Form.Item>
              </Col>
              <Col flex='auto'>
                <Row>
                  <Form.Item
                    className='ef-item'
                    name='date'
                    rules={[{ required: true }]}
                    label='Days from surgery'
                  >
                    <InputNumber rows={3} placeholder={'Days'} />
                  </Form.Item>
                </Row>
              </Col>
            </Row>
            <Row>
              <Form.Item
                className='ef-item'
                name='message'
                rules={[{ required: true }]}
                label='Message'
              >
                <Input.TextArea rows={3} placeholder={'Message'} />
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </List.Item>
  )
}

EventItem.propTypes = {
  event: propTypes.object,
  isLoading: propTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.event.isLoading,
    customer: state.profile.customer,
    company: state.profile.company,
    surgerytype: state.event.surgerytype,
    events: state.event.events,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    editEvent: (params, events) => dispatch(addEditEvent(params, events)),
    deleteEvent: (params, events) => dispatch(deleteEvent(params, events)),
    setEvents: (events, surgerytype) =>
      dispatch(setEventList(events, surgerytype)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventItem)
